import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { TherapistAction } from '../../actions/constant';
import therapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';

const {
  UPDATE_RECURRING_SERIES_REQUEST,
  UPDATE_RECURRING_SERIES_SUCCESS,
  UPDATE_RECURRING_SERIES_FAILURE,
} = TherapistAction;

function* updateRecurringSeries(action: any): SagaReturnType<any> {
  try {
    const response = yield call(
      therapistSchedulingServices.updateRecurringSeries,
      action.payload
    );
    if (response?.status === 200 || response?.status === 201) {
      yield put({ type: UPDATE_RECURRING_SERIES_SUCCESS, payload: response.data });
    } else {
      console.error('Unexpected response status:', response?.status);
      throw response.data;
    }
  } catch (error) {
    console.error('Update Recurring Series Error:', error);
    yield put({ type: UPDATE_RECURRING_SERIES_FAILURE, payload: error });
  }
}

function* updateRecurringSeriesSaga() {
  yield takeEvery(UPDATE_RECURRING_SERIES_REQUEST, updateRecurringSeries);
}

export default updateRecurringSeriesSaga;
